import { __rest, __assign } from '../../node_modules/tslib/tslib.es6.js';
import React, { forwardRef } from 'react';
import { classNames } from '../../helpers/classnames.js';
import { Icon } from '../Icon/Icon.js';
import { Typography } from '../Typography/Typography.js';

var Label = forwardRef(function (_a, ref) {
    var _b = _a.type, type = _b === void 0 ? 'default' : _b, assign = _a.assign, _c = _a.variant, variant = _c === void 0 ? 'outline' : _c, title = _a.title, iconName = _a.iconName, className = _a.className, props = __rest(_a, ["type", "assign", "variant", "title", "iconName", "className"]);
    // Обратная совместимость, атрибут variant как в Material UI
    if (assign) {
        console.warn('В компоненте Label вместо параметра assing используйте variant, assing в будущем будет удален.');
    }
    var optionedVariant = assign || variant;
    return (React.createElement("div", __assign({ "data-testid": "Label" }, props, { className: classNames('dsb_label', "dsb_label__".concat(optionedVariant), "dsb_label__".concat(type), iconName && 'dsb_label__with-icon', !title && 'dsb_label__without-title', className), ref: ref }),
        iconName && React.createElement(Icon, { className: "dsb_label-icon", iconName: iconName, size: "medium" }),
        optionedVariant !== 'icon' && title && (React.createElement(Typography, { className: "dsb_label-title", variant: "subtitle3" }, title))));
});

export { Label };
